import { TFunction } from 'i18next';
import { isExcludeProductSelection, ProductSelection } from '../../shared/product-selection/ProductSelectionTypes';
import Utils from '../../shared/utils';
import { globalErrorResponse } from '../../shared/notification/actions';
import { removeFromCart } from './removeProductsFromCartByLineItemKeys';
import { ListContentSource } from '../../store/constants';
import { NotificationState } from '../../app-store/notification/notificationReducer';

type FailAddToCartParams = {
    t: TFunction;
    error: any;
    source: ListContentSource;
    productSelection?: ProductSelection;
    onSuccess?: () => void;
    showNotificationWithInfo: (info: NotificationState) => void;
};

export function failUpdateToCart({
    t,
    error,
    source,
    productSelection,
    onSuccess,
    showNotificationWithInfo
}: FailAddToCartParams) {
    if (!error.runtimeDuplication) {
        switch (error.response.status) {
            case 409: {
                const data = error.response.data;
                if (data.additionalInfo) {
                    const infoData = data.additionalInfo.map(p => Utils.withdrawnProductLine(p)).join('<br/>');
                    const isSelectedAllRequest = isExcludeProductSelection(productSelection);

                    const failMessage = isSelectedAllRequest
                        ? t('notifications.failAddToCart.fail')
                        : t('notifications.failAddToCart.proceed');
                    const showCancelButton = !isSelectedAllRequest;

                    const unavailableProductsSelection = {
                        included: data.additionalInfo.map(({ lineItemKey }) => lineItemKey)
                    };

                    showNotificationWithInfo({
                        title: data.message,
                        message: failMessage,
                        dataDisplay: infoData,
                        dataRaw: data.additionalInfo,
                        callback: showCancelButton
                            ? () =>
                                  removeFromCart({
                                      productSelection: unavailableProductsSelection,
                                      source,
                                      onSuccess,
                                      t
                                  })
                            : null,
                        showCancel: showCancelButton
                    });
                    break;
                }
                globalErrorResponse(error);
                break;
            }
            default:
                globalErrorResponse(error);
        }
    }
}
